var map = {
	"./avatar.png": "./src/shared/assets/img/avatar.png",
	"./backgroup.png": "./src/shared/assets/img/backgroup.png",
	"./backgroup1.png": "./src/shared/assets/img/backgroup1.png",
	"./bg_indicators.png": "./src/shared/assets/img/bg_indicators.png",
	"./bg_inlist.png": "./src/shared/assets/img/bg_inlist.png",
	"./box_in1.png": "./src/shared/assets/img/box_in1.png",
	"./box_in4.png": "./src/shared/assets/img/box_in4.png",
	"./box_in44.png": "./src/shared/assets/img/box_in44.png",
	"./box_in7.png": "./src/shared/assets/img/box_in7.png",
	"./calculate.png": "./src/shared/assets/img/calculate.png",
	"./contact.png": "./src/shared/assets/img/contact.png",
	"./contact_page.png": "./src/shared/assets/img/contact_page.png",
	"./contentimgset.png": "./src/shared/assets/img/contentimgset.png",
	"./en.png": "./src/shared/assets/img/en.png",
	"./favicon_io/android-chrome-192x192.png": "./src/shared/assets/img/favicon_io/android-chrome-192x192.png",
	"./favicon_io/android-chrome-512x512.png": "./src/shared/assets/img/favicon_io/android-chrome-512x512.png",
	"./favicon_io/apple-touch-icon.png": "./src/shared/assets/img/favicon_io/apple-touch-icon.png",
	"./favicon_io/favicon-16x16.png": "./src/shared/assets/img/favicon_io/favicon-16x16.png",
	"./favicon_io/favicon-32x32.png": "./src/shared/assets/img/favicon_io/favicon-32x32.png",
	"./icon_user.png": "./src/shared/assets/img/icon_user.png",
	"./imgbox.png": "./src/shared/assets/img/imgbox.png",
	"./imggroup1.png": "./src/shared/assets/img/imggroup1.png",
	"./imggroup10.png": "./src/shared/assets/img/imggroup10.png",
	"./imggroup11.png": "./src/shared/assets/img/imggroup11.png",
	"./imggroup12.png": "./src/shared/assets/img/imggroup12.png",
	"./imggroup13.png": "./src/shared/assets/img/imggroup13.png",
	"./imggroup2.png": "./src/shared/assets/img/imggroup2.png",
	"./imggroup3.png": "./src/shared/assets/img/imggroup3.png",
	"./imggroup4.png": "./src/shared/assets/img/imggroup4.png",
	"./imggroup5.png": "./src/shared/assets/img/imggroup5.png",
	"./imggroup6.png": "./src/shared/assets/img/imggroup6.png",
	"./imggroup7.png": "./src/shared/assets/img/imggroup7.png",
	"./imggroup8.png": "./src/shared/assets/img/imggroup8.png",
	"./imggroup9.png": "./src/shared/assets/img/imggroup9.png",
	"./landdingpage1.png": "./src/shared/assets/img/landdingpage1.png",
	"./landdingpage2.png": "./src/shared/assets/img/landdingpage2.png",
	"./landdingpage3.png": "./src/shared/assets/img/landdingpage3.png",
	"./logis1_1.png": "./src/shared/assets/img/logis1_1.png",
	"./logistic/logis1.png": "./src/shared/assets/img/logistic/logis1.png",
	"./logistic/logis1_1.png": "./src/shared/assets/img/logistic/logis1_1.png",
	"./logistic/logis1_2.png": "./src/shared/assets/img/logistic/logis1_2.png",
	"./logistic/logis1_3.png": "./src/shared/assets/img/logistic/logis1_3.png",
	"./logistic/logis1_4.png": "./src/shared/assets/img/logistic/logis1_4.png",
	"./logistic/logis2.png": "./src/shared/assets/img/logistic/logis2.png",
	"./logistic/logis2_1.png": "./src/shared/assets/img/logistic/logis2_1.png",
	"./logistic/logis2_10.png": "./src/shared/assets/img/logistic/logis2_10.png",
	"./logistic/logis2_11.png": "./src/shared/assets/img/logistic/logis2_11.png",
	"./logistic/logis2_2.png": "./src/shared/assets/img/logistic/logis2_2.png",
	"./logistic/logis2_3.png": "./src/shared/assets/img/logistic/logis2_3.png",
	"./logistic/logis2_4.png": "./src/shared/assets/img/logistic/logis2_4.png",
	"./logistic/logis2_5.png": "./src/shared/assets/img/logistic/logis2_5.png",
	"./logistic/logis2_6.png": "./src/shared/assets/img/logistic/logis2_6.png",
	"./logistic/logis2_7.png": "./src/shared/assets/img/logistic/logis2_7.png",
	"./logistic/logis2_8.png": "./src/shared/assets/img/logistic/logis2_8.png",
	"./logistic/logis2_9.png": "./src/shared/assets/img/logistic/logis2_9.png",
	"./logistic/logis3.png": "./src/shared/assets/img/logistic/logis3.png",
	"./logistic/logis3_1.png": "./src/shared/assets/img/logistic/logis3_1.png",
	"./logistic/logis3_10.png": "./src/shared/assets/img/logistic/logis3_10.png",
	"./logistic/logis3_11.png": "./src/shared/assets/img/logistic/logis3_11.png",
	"./logistic/logis3_2.png": "./src/shared/assets/img/logistic/logis3_2.png",
	"./logistic/logis3_3.png": "./src/shared/assets/img/logistic/logis3_3.png",
	"./logistic/logis3_4.png": "./src/shared/assets/img/logistic/logis3_4.png",
	"./logistic/logis3_5.png": "./src/shared/assets/img/logistic/logis3_5.png",
	"./logistic/logis3_6.png": "./src/shared/assets/img/logistic/logis3_6.png",
	"./logistic/logis3_7.png": "./src/shared/assets/img/logistic/logis3_7.png",
	"./logistic/logis3_8.png": "./src/shared/assets/img/logistic/logis3_8.png",
	"./logistic/logis3_9.png": "./src/shared/assets/img/logistic/logis3_9.png",
	"./logistic/logis4.png": "./src/shared/assets/img/logistic/logis4.png",
	"./logistic/logis4_1.png": "./src/shared/assets/img/logistic/logis4_1.png",
	"./logistic/logis4_2.png": "./src/shared/assets/img/logistic/logis4_2.png",
	"./logistic/logis4_3.png": "./src/shared/assets/img/logistic/logis4_3.png",
	"./logistic/logis5.png": "./src/shared/assets/img/logistic/logis5.png",
	"./logistic/logis5_1.png": "./src/shared/assets/img/logistic/logis5_1.png",
	"./logo.png": "./src/shared/assets/img/logo.png",
	"./logox2.png": "./src/shared/assets/img/logox2.png",
	"./maps.png": "./src/shared/assets/img/maps.png",
	"./pin.png": "./src/shared/assets/img/pin.png",
	"./th.png": "./src/shared/assets/img/th.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/shared/assets/img sync recursive ^\\.\\/.*\\.png$";